import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AdminControl } from '../../models/admin-control/admin-control.model';
import { SubscriptionMassActivationResultModel } from '../../models/subscription-mass-activation/subscription-mass-activation.model';

@Injectable({
    providedIn: 'root'
})
export class AdminPanelService {
    private uri = environment.apiUrl + '/mainPanel';

    constructor(private readonly http: HttpClient) { }

    public getAdminControls(): Observable<Array<AdminControl>> {
        return this.http.get<Array<AdminControl>>(`${this.uri}/manage-controls`);
    }

    public upsertAdminControls(items: Array<AdminControl>): Observable<void> {
        return this.http.put<void>(`${this.uri}/manage-controls`, { items });
    }

    public subscriptionMassActivation(partnerId: number, targetConnectorId: number, isAssessment: boolean): Observable<SubscriptionMassActivationResultModel> {
        return this.http.post<SubscriptionMassActivationResultModel>(`${this.uri}/sma`, { partnerId, targetConnectorId, isAssessment });
    }
}
